import type { PageLink } from '@/lib/pageOrder';

interface PageNavigationProps {
  prev: PageLink | null;
  next: PageLink | null;
  onNavigate: (path: string) => void;
}

/**
 * Previous / Next under the article. A card shows one line of the page's
 * title (the CSS cuts the rest with an ellipsis, see .page-nav in
 * docs-shared.css), so each button also carries the whole title.
 */
export function PageNavigation({ prev, next, onNavigate }: PageNavigationProps) {
  if (!prev && !next) return null;

  return (
    <div className="page-nav">
      {prev ? (
        <button type="button" onClick={() => onNavigate(prev.path)} className="prev" title={prev.title}>
          <span className="nav-label">&larr; Previous</span>
          <span className="nav-title">{prev.title}</span>
        </button>
      ) : (
        <span />
      )}
      {next ? (
        <button type="button" onClick={() => onNavigate(next.path)} className="next" title={next.title}>
          <span className="nav-label">Next &rarr;</span>
          <span className="nav-title">{next.title}</span>
        </button>
      ) : (
        <span />
      )}
    </div>
  );
}
